import {DotPadSendModule, RefreshMode} from "./DotPadSendModule";
import {DotpadResize} from "./DotpadResize";
import {DotPadInfo} from "./DotPadInfo";
import dotPadTrace from "./dotPadTrace"

// 앞 전송이 끝났는지 지켜보는 간격. 고정 지연으로 기다리면 그만큼 출력이 늦어진다.
const SEND_POLL_INTERVAL = 20

class DotpadSDK {  // eslint-disable-line no-unused-vars
    constructor(dotPad) {
        this.VOXEL_ROW_NUM = 40 // 40(닷패드320) || 64(닷패드768)
        this.VOXEL_COL_NUM = 60 // 60(닷패드320) || 96(닷패드768)
        this.LINE_HEIGHT = 20
        this.DOT_CELL_PIN = 8
        this.dot_Matrix_All = this.create2DArray(this.VOXEL_ROW_NUM, this.VOXEL_COL_NUM)
        this.dtm_Data = new Uint8Array(300) // 2400(60x40) / 8 = 300, 6144(96x64) / 8 = 768
        this.length = 10    // 디바이스 셀 ROW 수 10(300) || 16(768)
        this.numCell = 30   // 디바이스 셀 COL 수 30(300) || 48(768)
        this.stringwithPadding = ""
        this.indexPadding = 1
        this.SubString = ""
        this.writeString_Wrap = ""
        this.writeString = ""
        this.res = false
        this.dotPad = dotPad
        this.dotPadSendModule = new DotPadSendModule(dotPad)
        this.lineCount = 0
        this.cellTotal = 300
        this.DOT_PAD_INFO = {}
        this.sendMessageMode = null
        this.isRunning = false
        this.lastTask = null
        // 전송 중에 들어온 화면은 쌓아 두지 않고 마지막 것만 남긴다
        this.pendingMessage = null
        this.pendingTimer = null

        if (dotPad) {
            this.dotPadSendModule.addDotPadLine(this.length, this.numCell)
            dotPad.setDotPadSendModule(this.dotPadSendModule)
        }
    }

    /**
     캔버스 정보가 고정값(40, 60 -> 64, 90 등)이 였던 것을 닷패드 정보에 따라 변경
     - param dotPadInfo{cellTotal, height, width}
     */
    setDotPadSDKInfo(dotPadInfo) {
        this.DOT_PAD_INFO = new DotPadInfo(dotPadInfo?.totalCell + '')

        // 추후 변수 제거해야함
        this.cellTotal = this.DOT_PAD_INFO.totalCell;
        this.VOXEL_ROW_NUM = this.DOT_PAD_INFO.height;
        this.VOXEL_COL_NUM = this.DOT_PAD_INFO.width;
        this.dot_Matrix_All = this.DOT_PAD_INFO.totalMatrix;
        this.dtm_Data = this.DOT_PAD_INFO.dtmData;
        this.length = this.DOT_PAD_INFO.totalCellLine;
        this.numCell = this.DOT_PAD_INFO.halfWidth;
        this.LINE_HEIGHT = this.DOT_PAD_INFO.halfHeight;

        if (this.dotPad) {
            this.dotPadSendModule.addDotPadLine(this.length, this.numCell);
            this.dotPad.setDotPadSendModule(this.dotPadSendModule);
        }
    }

    create2DArray(rows, columns) {
        var arr = new Array(rows);
        for (var i = 0; i < rows; i++) {
            arr[i] = new Array(columns);
        }
        return arr;
    }

    toHexString(byteArray) {
        return Array.from(byteArray, function (byte) {
            return ('0' + (byte & 0xFF).toString(16)).slice(-2);
        }).join('')
    }

    decimalToHex(d, padding) {
        var hex = Number(d).toString(16);
        padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

        while (hex.length < padding) {
            hex = "0" + hex;
        }

        return hex;
    }

    // Convert a hex string to a byte array
    hexToBytes(hex) {
        const bytes = [];

        try {
            for (let c = 0; c < hex.length; c += 2)
                bytes.push(parseInt(hex.substring(c, c + 2), 16));
        } catch (e) {
            console.error(e);
        }

        return bytes;
    }

    /**
     * Convert a hex string to an ArrayBuffer.
     *
     * @param {string} hexString - hex representation of bytes
     * @return {ArrayBuffer} - The bytes in an ArrayBuffer.
     */
    hexStringToArrayBuffer(hexString) {
        // remove the leading 0x
        hexString = hexString.replace(/^0x/, '');

        // ensure even number of characters
        if (hexString.length % 2 !== 0) {
            console.log('WARNING: expecting an even number of characters in the hexString');
        }

        // check for some non-hex characters
        var bad = hexString.match(/[G-Z\s]/i);
        if (bad) {
            console.log('WARNING: found non-hex characters', bad);
        }

        // split the string into pairs of octets
        var pairs = hexString.match(/[\dA-F]{2}/gi);

        // convert the octets to integers
        var integers = pairs.map(function (s) {
            return parseInt(s, 16);
        });

        var array = new Uint8Array(integers);
        // console.log(array);

        return array.buffer;
    }

    /**
     * Converts a 600-character hex string to an array of 2400 Boolean values.
     *
     * @param { string } hexString - A 600-character hex string (1 hex = 4 bits).
     * @return { boolean[] } - An array of 2400 Boolean values.
     */
    hexToBooleanArray = (hexString) => {
        // 300 Bytes Array
        const byteArray = this.hexToBytes(hexString) //byteArray length는 닷 패드 설정에 따라 300, 768 셀로 나뉨
        const booleanArray = new Array(byteArray.length * 8).fill(false)

        const canvasWidth = byteArray.length === 300 ? 60 : 96
        const canvasWidthHalf = byteArray.length === 300 ? 30 : 48

        for (let i = 0; i < byteArray.length; i++) {
            const startIndex = Math.floor(i / canvasWidthHalf) * canvasWidth * 4 + (i % canvasWidthHalf) * 2
            for (let bit = 0; bit < 8; bit++) {
                const index = startIndex + (bit % 4) * canvasWidth + Math.floor(bit / 4)
                booleanArray[index] = !!(byteArray[i] & (1 << bit))
            }
        }
        return booleanArray
    }

    checksum(test_data) {
        var check = 0xA5;

        for (var i = 0; i < test_data.length; i++) {
            check = check ^ test_data[i]
            //console.log(i, test_data[i+4].toString(16), check.toString(16));
        }
        let res = ('0' + (check & 0xFF).toString(16)).slice(-2);
        return res;
    }

    /**
     Make a Data set using Application's Canvas Data(voxels: Array<Array<Bool>>).
     - warning: None.
     - parameter deviceType: DeviceType
     - parameter voxels: Array<Array<Bool>>
     - returns:
     */
    Load_mapFile(voxels) {
        //console.log("[DotpadSDK.js] - Load_mapFile this.VOXEL_ROW_NUM ? ", this.VOXEL_ROW_NUM, ", this.VOXEL_COL_NUM ? ", this.VOXEL_COL_NUM);
        let order = 0
        for (let i = 0; i < this.VOXEL_ROW_NUM; i++) {
            for (let j = 0; j < this.VOXEL_COL_NUM; j++) {
                if (voxels[order] == true) {
                    this.dot_Matrix_All[i][j] = 0x01
                } else {
                    this.dot_Matrix_All[i][j] = 0x00
                }
                order++;
            }
        }
        //console.log('this.dot_Matrix_All : ' + this.dot_Matrix_All.length + ", " + this.dot_Matrix_All[0].length + " : " + this.dot_Matrix_All);
    }

    /**
     Make a One Cell Data.
     - warning: None.
     - parameter cell_ID: Int
     - returns: None
     */
    Sub_dot_Cell_Matrix(cell_ID) {
        //const halfWidth = this.DOT_PAD_INFO.halfWidth
        const halfWidth = 30
        const startIndex = parseInt(cell_ID / halfWidth)
        const endIndex = parseInt(cell_ID % halfWidth)
        
        let _dot_Cell = this.create2DArray(4, 2)
        _dot_Cell[0][0] = this.dot_Matrix_All[startIndex * 4][endIndex * 2]
        _dot_Cell[0][1] = this.dot_Matrix_All[startIndex * 4][endIndex * 2 + 1]
        _dot_Cell[1][0] = this.dot_Matrix_All[startIndex * 4 + 1][endIndex * 2]
        _dot_Cell[1][1] = this.dot_Matrix_All[startIndex * 4 + 1][endIndex * 2 + 1]

        _dot_Cell[2][0] = this.dot_Matrix_All[startIndex * 4 + 2][endIndex * 2]
        _dot_Cell[2][1] = this.dot_Matrix_All[startIndex * 4 + 2][endIndex * 2 + 1]
        _dot_Cell[3][0] = this.dot_Matrix_All[startIndex * 4 + 3][endIndex * 2]
        _dot_Cell[3][1] = this.dot_Matrix_All[startIndex * 4 + 3][endIndex * 2 + 1]

        return _dot_Cell
    }
    
    Sub_dot_Cell_Matrix_FOR_DotPad768(cell_ID) {
        const halfWidth = 48
        const startIndex = parseInt(cell_ID / halfWidth)
        const endIndex = parseInt(cell_ID % halfWidth)

        let _dot_Cell = this.create2DArray(4, 2);
        //로우, 컬럼
        _dot_Cell[0][0] = this.dot_Matrix_All[startIndex * 4][endIndex * 2]
        _dot_Cell[0][1] = this.dot_Matrix_All[startIndex * 4][endIndex * 2 + 1]
        _dot_Cell[1][0] = this.dot_Matrix_All[startIndex * 4 + 1][endIndex * 2]
        _dot_Cell[1][1] = this.dot_Matrix_All[startIndex * 4 + 1][endIndex * 2 + 1]
        
        _dot_Cell[2][0] = this.dot_Matrix_All[startIndex * 4 + 2][endIndex * 2]
        _dot_Cell[2][1] = this.dot_Matrix_All[startIndex * 4 + 2][endIndex * 2 + 1]
        _dot_Cell[3][0] = this.dot_Matrix_All[startIndex * 4 + 3][endIndex * 2]
        _dot_Cell[3][1] = this.dot_Matrix_All[startIndex * 4 + 3][endIndex * 2 + 1]
        
        return _dot_Cell;
    }
    
    /**
     Transform One Cell Data to Byte Value.
     - warning: None.
     - parameter sub_Cell: [[UInt8]]
     - returns: [[UInt8]]
     */
    Get_dot_Cell_Byte(sub_Cell) {
        var cell_Byte = 0x0

        cell_Byte = ((sub_Cell[0][0]) + ((sub_Cell[0][1] << 4) & 0xff) + ((sub_Cell[1][0] << 1) & 0xff));
        cell_Byte = cell_Byte + (((sub_Cell[1][1] << 5) & 0xff) + ((sub_Cell[2][0] << 2) & 0xff));
        cell_Byte = cell_Byte + (((sub_Cell[2][1] << 6) & 0xff) + ((sub_Cell[3][0] << 3) & 0xff));
        cell_Byte = cell_Byte + (((sub_Cell[3][1] << 7) & 0xff));

        //console.log('[DotpadSDK.js] - Get_dot_Cell_Byte - cell_Byte : ' + cell_Byte);
        return cell_Byte;
    }
    /**
     DTM PREFIX 포멧 없이 DTM 파일 생성
     */
    Make_DTM_Data() {
        let _dot_Cell = this.create2DArray(4, 2)

        for (let Cell_ID = 0; Cell_ID < this.cellTotal; Cell_ID++) {
            _dot_Cell = this.cellTotal === 768
                ? this.Sub_dot_Cell_Matrix_FOR_DotPad768(Cell_ID)
                : this.Sub_dot_Cell_Matrix(Cell_ID)

            this.dtm_Data[Cell_ID] = this.Get_dot_Cell_Byte(_dot_Cell)
        }

        this.writeString = this.toHexString(this.dtm_Data);
    }

    /**
     Send Data of Application's Canvas Data to dotPad_Communication.
     - warning: None.
     - parameter
     - returns: None.
     */
    async sendPixelPattern() {
        await this.sendMessage(this.writeString)
    }

    sendLine(i, mode) {
        const commandCode = mode === "GRAPHIC" ? "00" : "80"
        const step = i - 1

        this.SubString = this.stringwithPadding.substring(step * this.numCell * 2, ((step + 1) * this.numCell * 2))
        this.dotPadSendModule.setRefreshMode(RefreshMode.GRAPHIC_DISPLAY)
        this.dotPadSendModule.setDotPadLineCommand(i, commandCode, 0, this.SubString)
    }
   
    /**
     * Sends data to the DotPad display graphic area through the `dotPad_Communication`.
     *
     * @async
     * @param { string } writeString
     * @param { "GRAPHIC" | "TEXT" } mode
     * @param { {force?: boolean} } [options] force 면 diff 와 대기열을 무시하고 전 라인을 지금 보낸다
     * @returns { Promise<void> }
     */
    async sendMessage(writeString, mode = "GRAPHIC", {force = false} = {}) { // eslint-disable-line no-unused-vars
        if (!writeString) return
        if (writeString.length !== this.length * this.numCell * 2) return

        if (force) {
            return this.sendMessageForce(writeString, mode)
        }

        // 앞 전송이 아직 끝나지 않았으면 마지막 화면만 남겨 두었다가 끝나는 즉시 보낸다.
        // 확대 스크롤처럼 출력이 연달아 들어올 때 지나간 화면을 보내느라 밀리지 않게 한다.
        if (!this.dotPadSendModule.getDisplayComplete()) {
            this.pendingMessage = {writeString, mode}
            this.schedulePendingMessage()
            return
        }

        this.stringwithPadding = writeString

        for (let i = 1; i <= this.length; i++) {
            this.setLineDiff(i, mode)
        }
        await this.dotPadSendModule.sendCommand()
    }

    /**
     * 화면을 떠나며 핀을 내릴 때처럼 "기기가 지금 무엇을 보이고 있든" 이 화면이어야 할 때 쓴다.
     *
     * 보통 전송은 lineData 와의 diff 만 보낸다. 그런데 lineData 는 라인이 큐에 들어갈 때 갱신되고
     * 실제 전달과는 별개라, 프레임이 버려지거나 ACK 를 포기한 뒤에는 기기 화면과 어긋난 채 남는다.
     * 그 상태에서 diff 로 0 을 보내면 "변화 없음"으로 판정돼 한 라인도 나가지 않고, 홈 화면에
     * 직전 그림이 그대로 남았다(QA). 그래서 여기서는
     *  1) 돌고 있는 프레임을 버리고(그 내용은 이제 의미가 없다),
     *  2) 대기열에 남은 옛 화면도 버린다(0 을 보낸 뒤 20ms 폴링이 옛 그림을 되살리던 경로),
     *  3) 전 라인을 diff 없이 세워 보낸다.
     */
    async sendMessageForce(writeString, mode = "GRAPHIC") {
        this.pendingMessage = null
        if (this.pendingTimer) {
            clearTimeout(this.pendingTimer)
            this.pendingTimer = null
        }
        this.dotPadSendModule.abandonRunningFrame?.("force-send")

        this.stringwithPadding = writeString

        for (let i = 1; i <= this.length; i++) {
            this.sendLine(i, mode)
        }
        await this.dotPadSendModule.sendCommand()
    }

    cancelPendingOutput() {
        this.pendingMessage = null
        clearTimeout(this.pendingTimer)
        this.pendingTimer = null
        this.dotPadSendModule.cancelPendingOutput()
    }

    /**
     * 밀려 있는 마지막 화면을 앞 전송이 끝나는 대로 내보낸다.
     * @returns { void }
     */
    schedulePendingMessage() {
        if (this.pendingTimer) return

        this.pendingTimer = setTimeout(() => {
            this.pendingTimer = null

            const pending = this.pendingMessage
            if (!pending) return

            if (!this.dotPadSendModule.getDisplayComplete()) {
                this.schedulePendingMessage()
                return
            }

            this.pendingMessage = null
            this.sendMessage(pending.writeString, pending.mode)
        }, SEND_POLL_INTERVAL)
    }

    async sendMessageDiff(writeString, mode = "GRAPHIC", complete = false) { // eslint-disable-line no-unused-vars
        this.stringwithPadding = writeString
        
        if (!this.stringwithPadding) return
        if (this.stringwithPadding.length !== this.length * this.numCell * 2) return
        if (this.isRunning) return
        
        let sendReady = false
        for (let i = 1; i <= this.length; i++) {
            if (this.setLineDiff(i, mode, complete)) {
                sendReady = true
            }
        }
        
        if (sendReady) {
            if (!complete || !this.dotPadSendModule.getIsFunctionRunning() || this.dotPad.deviceInfo.cellType === "D3") {
                await this.dotPadSendModule.sendCommand();
            } else {
                // 라인은 이미 세웠는데(=lineData 갱신) 전송은 시작하지 않는 분기.
                // 돌고 있는 루프가 집어 가지 못하면 그 내용은 영영 안 나간다.
                dotPadTrace.log("send.queuedOnly", {
                    running: this.dotPadSendModule.getIsFunctionRunning(),
                    index: this.dotPadSendModule.currentIndex,
                    refreshCount: this.dotPadSendModule.refreshCount
                })
            }
        } else {
            // 보낼 차이가 없다고 판정한 경우. 마지막 획이 안 넘어갈 때 여기가 찍히면
            // lineData 가 이미 "보냈다"고 기록하고 있다는 뜻이다.
            dotPadTrace.log("diff.none", { complete })
            this.dotPadSendModule.setRefreshMode(RefreshMode.NONE)
        }
    }
    
    async runTask(task) {
        if (this.isRunning) {
            this.lastTask = task
            return
        }
        
        this.isRunning = true
        
        let currentTask = task
        
        while (currentTask) {
            await currentTask()
            currentTask = this.lastTask
            this.lastTask = null
        }
        
        this.isRunning = false
    }

    getTextDisplaySlice(textString, index) {
        const normalizedText = `${textString ?? ""}`.replace(/\s/g, "")
        if (normalizedText.length < 1) return ""

        const maxIndex = Math.max(Math.ceil(normalizedText.length / 40) - 1, 0)
        const numericIndex = Number.isFinite(Number(index)) ? Number(index) : 0
        const currentIndex = Math.min(Math.max(numericIndex, 0), maxIndex)

        const slice = normalizedText
            .substring(currentIndex * 20 * 2, (currentIndex + 1) * 20 * 2)
            .padEnd(40, "0")

        return slice
    }

    async sendText(textString, index) {
        if (parseInt(this.dotPad.deviceInfo.colCellSize) === 48) return
        if (`${textString ?? ""}`.length < 1) return

        this.SubString = this.getTextDisplaySlice(textString, index)
        if (this.SubString.length < 1) return

        if (this.dotPad != null && this.dotPad.connected) {
            this.dotPadSendModule.setRefreshMode(RefreshMode.TEXT_DISPLAY)
            this.dotPadSendModule.setDotPadLineCommand(0, "80", "00", this.SubString)
            await this.dotPadSendModule.sendCommand()

            return true
        }
    }

    setText(textString, index) {
        if (parseInt(this.dotPad.deviceInfo.colCellSize) === 48) return
        if (`${textString ?? ""}`.length < 1) return

        this.SubString = this.getTextDisplaySlice(textString, index)
        if (this.SubString.length < 1) return

        if (this.dotPad != null && this.dotPad.connected) {
            this.dotPadSendModule.setRefreshMode(RefreshMode.TEXT_DISPLAY)
            this.dotPadSendModule.setDotPadLineCommand(0, "80", "00", this.SubString)
            
            return true
        }
    }

    getGraphicCellCount() {
        const colCellSize = parseInt(this.dotPad?.deviceInfo?.colCellSize)
        const rowCellSize = parseInt(this.dotPad?.deviceInfo?.rowCellSize)

        if (colCellSize > 0 && rowCellSize > 0) {
            return colCellSize * rowCellSize
        }

        return this.DOT_PAD_INFO?.totalCell || this.cellTotal
    }

    /**
     * @param { {force?: boolean} } [options] force 면 diff·대기열을 무시하고 전 라인을 지금 보낸다
     *   (sendMessageForce 참고). 기본값은 예전 그대로 diff 전송이라 앱 모드 호출처는 바뀌지 않는다.
     */
    downAllCell({force = false} = {}) {
        const graphicCellCount = this.getGraphicCellCount()

        if (graphicCellCount !== this.cellTotal) {
            this.setDotPadSDKInfo({totalCell: graphicCellCount})
        }

        if (this.dotPad && parseInt(this.dotPad.deviceInfo.colCellSize) !== 48) {
            this.setText("00".repeat(20), 0)
        }

        return this.sendMessage("00".repeat(graphicCellCount), "GRAPHIC", {force})
    }

    /**
     * @param brailleText
     * @returns {string}
     */
    convertGraphicToTextHex(brailleText) {
        const splitStrings = this.hexToBinary(brailleText).match(/.{1,8}/g);
        const swappedStrings = splitStrings.map((subStr, index) => {
            const pin1 = subStr.substring(7, 8);
            const pin2 = subStr.substring(6, 7);
            const pin3 = subStr.substring(5, 6);
            const pin4 = subStr.substring(4, 5);
            const pin5 = subStr.substring(3, 4);
            const pin6 = subStr.substring(2, 3);
            const pin7 = subStr.substring(1, 2);
            const pin8 = subStr.substring(0, 1);

            return pin8 + pin4 + pin7 + pin6 + pin5 + pin3 + pin2 + pin1;
        });
        // 3. 조인하고 다시 16진수로 변환
        return this.binaryToHex(swappedStrings.join(""));
    }

    /**
     * @param tactileLetters
     * @param {number} numberOfPins
     * @returns {string}
     */
    changeTactileLettersGraphicDisplayText(brailleText) {
        const splitStrings = this.hexToBinary(brailleText).match(/.{1,8}/g);
        const swappedStrings = splitStrings.map((subStr) => {
            return subStr.substring(0, 1) + subStr.substring(2, 5) + subStr.substring(1, 2) + subStr.substring(5);
        });
        // 3. 조인하고 다시 16진수로 변환
        return this.binaryToHex(swappedStrings.join(""));
    }

    hexToBinary(hex) {
        let binary = "";
        for (let i = 0; i < hex.length; i++) {
            const decimal = parseInt(hex[i], 16);
            const fourBits = decimal.toString(2).padStart(4, "0");
            binary += fourBits;
        }
        return binary;
    }

    binaryToHex(binary) {
        let hex = "";
        let i = 0;
        while (i < binary.length) {
            const fourBits = binary.substring(i, i + 4);
            const decimal = parseInt(fourBits, 2);
            hex += decimal.toString(16).toUpperCase();
            i += 4;
        }
        return hex;
    }

    /**
     * @param brailleText
     * @param {number} numberOfPins // 6 dot / 8 dot
     * @param {array} drawPoints
     * @param {number} [letterSpacing] // 0: no spacing, 1: spacing
     * @returns {string}
     */
    changeGraphicDisplayMultiline(brailleText, numberOfPins, drawPoints, letterSpacing = 1) {
        const splitStrings = this.hexToBinary(brailleText).match(/.{1,8}/g);
        this.lineCount = 0;
        const effectiveLineHeight = letterSpacing === 0 ? Math.round(this.LINE_HEIGHT * 1.5) : this.LINE_HEIGHT;
        // console.log("[DotpadSDK] changeGraphicDisplayMultiline letterSpacing:", letterSpacing, "LINE_HEIGHT:", this.LINE_HEIGHT, "effectiveLineHeight:", effectiveLineHeight, "splitStrings.length:", splitStrings?.length)
        let tempDotCellLineData = this.createTempDotCellLineData(splitStrings, numberOfPins, letterSpacing, effectiveLineHeight);
        // console.log("[DotpadSDK] tempDotCellLineData.length:", tempDotCellLineData.length, "drawPoints.length:", drawPoints.length)
        let dotCellLineData = [];
        const drawPointHandlers = {
            '0000': this.handle0000.bind(this),
            '0001': this.handle0001.bind(this),
            '0011': this.handle0011.bind(this),
            '0111': this.handle0111.bind(this),
            '1000': this.handle1000.bind(this),
            '1001': this.handle1001.bind(this),
            '1011': this.handle1011.bind(this),
            '1100': this.handle1100.bind(this),
            '1101': this.handle1101.bind(this),
            '1110': this.handle1110.bind(this),
            '1111': this.handle1111.bind(this),
        }

        drawPoints.forEach((drawPointArr) => {
            let drawPoint = drawPointArr.join().replaceAll(',', '');
            if (drawPointHandlers[drawPoint]) {
                drawPointHandlers[drawPoint](tempDotCellLineData, dotCellLineData, numberOfPins);
            }
        });

        // 3. 조인하고 다시 16진수로 변환
        return this.binaryToHex(dotCellLineData.join(""));
    }

    /**
     * Before applying dot cell data blank
     * @param {array} splitStrings
     * @param {number} numberOfPins
     * @param {number} [letterSpacing]
     * @param {number} [lineHeight]
     * @returns {array}
     */
    createTempDotCellLineData(splitStrings, numberOfPins, letterSpacing = 1, lineHeight = null) {
        //console.log("[DotpadSDK.js] - createTempDotCellLineData splitStrings ?", splitStrings);
        const effectiveLineHeight = lineHeight ?? this.LINE_HEIGHT;
        let dotCellLineData = [];
        let rearrangeBits = [];
        splitStrings.forEach((subStr, index) => {
            const tempRearrangeBits = this.rearrangeBits(subStr, numberOfPins, index, rearrangeBits, letterSpacing);

            if ((index + 1) % effectiveLineHeight == 0) {
                dotCellLineData.push(tempRearrangeBits);
                rearrangeBits = [];
            }
        });

        if (rearrangeBits.length > 0) {
            dotCellLineData.push(rearrangeBits);
        }

        return dotCellLineData;
    }

    /**
     * rearrange the bit
     * @param {string} subStr
     * @param {number} numberOfPins
     * @param {number} index
     * @param {array} rearrangeBits
     * @param {number} [letterSpacing]
     * @returns {rearrangeBits}
     */
    rearrangeBits(subStr, numberOfPins, index, rearrangeBits, letterSpacing = 1) {
        // 1. 짝수 번째 텍스트 7, 8번 핀을 제외한 3비트씩 앞뒤로 위치를 바꾸고 8비트만큼 "0"으로 채움(6점식)
        //    짝수 번째 텍스트 7, 8번 핀을 포함한 3비트씩 앞뒤로 위치를 바꾸고 8비트만큼 "0"으로 채움(8점식)
        const number7Pin = numberOfPins === this.DOT_CELL_PIN ? subStr.substring(0, 1) : "0";
        const number8Pin = numberOfPins === this.DOT_CELL_PIN ? subStr.substring(1, 2) : "0";
        const bitsFromPins1To3 = subStr.substring(2, 5);
        const bitsFromPins4To6 = subStr.substring(5);
        if (letterSpacing !== 0 && index % 2 === 1) {
            rearrangeBits.push(number8Pin + bitsFromPins4To6 + "0000");
            rearrangeBits.push("0000" + number7Pin + bitsFromPins1To3);
        } else {
            rearrangeBits.push(number7Pin + bitsFromPins1To3 + number8Pin + bitsFromPins4To6);
        }

        return rearrangeBits;
    }

    handle0000(dotCellLineData) {
        let tempData = [];
        for (let i = 0; i < this.numCell; i++) {
            tempData.push("00000000");
        }
        dotCellLineData.push(tempData);
    }

    handle1111(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data);
            });
        }
        this.lineCount++;
    }

    handle0001(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data.substring(3, 4) + "000" + data.substring(7, 8) + "000");
            });
        }
    }

    handle0011(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data.substring(2, 4) + "00" + data.substring(6, 8) + "00");
            });
        }
    }

    handle0111(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data.substring(1, 4) + "0" + data.substring(5, 8) + "0");
            });
        }
        if (numberOfPins != this.DOT_CELL_PIN) {
            this.lineCount++;
        }
    }

    handle1000(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (numberOfPins != this.DOT_CELL_PIN) {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("000" + data.substring(1, 2) + "000" + data.substring(5, 6));
                });
            }
        } else {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("000" + data.substring(0, 1) + "000" + data.substring(4, 5));
                });
            }
        }
        this.lineCount++;
    }

    handle1001(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (tempDotCellLineData[this.lineCount]) {
            let tempData1 = [], tempData2 = [], tempData3 = [], tempData4 = [];
            if (numberOfPins != this.DOT_CELL_PIN) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    tempData1.push(data.substring(1, 2));
                    tempData2.push(data.substring(5, 6));
                });
            } else {
                if (tempDotCellLineData[this.lineCount]) {
                    tempDotCellLineData[this.lineCount].forEach(data => {
                        tempData1.push(data.substring(0, 1));
                        tempData2.push(data.substring(4, 5));
                    });
                }
            }
            if (tempDotCellLineData[this.lineCount + 1]) {
                tempDotCellLineData[this.lineCount + 1].forEach(data => {
                    tempData3.push(data.substring(3, 4) + "00");
                    tempData4.push(data.substring(7, 8) + "00");
                });
            } else {
                tempDotCellLineData[this.lineCount].forEach(() => {
                    tempData3.push("000");
                    tempData4.push("000");
                });
            }
            tempData1.forEach((data, i) => {
                dotCellLineData.push(tempData3[i] + data + tempData4[i] + tempData2[i]);
            });
        }
        this.lineCount++;
    }

    handle1011(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            let tempData1 = [], tempData2 = [], tempData3 = [], tempData4 = [];
            tempDotCellLineData[this.lineCount].forEach(data => {
                tempData1.push(data.substring(0, 1));
                tempData2.push(data.substring(4, 5));
            });
            if (tempDotCellLineData[this.lineCount + 1]) {
                tempDotCellLineData[this.lineCount + 1].forEach(data => {
                    tempData3.push(data.substring(2, 4) + "0");
                    tempData4.push(data.substring(6, 8) + "0");
                });
            } else {
                tempDotCellLineData[this.lineCount].forEach(() => {
                    tempData3.push("000");
                    tempData4.push("000");
                });
            }
            tempData1.forEach((data, i) => {
                dotCellLineData.push(tempData3[i] + data + tempData4[i] + tempData2[i]);
            });
        }
        this.lineCount++;
    }

    handle1100(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (numberOfPins != this.DOT_CELL_PIN) {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("00" + data.substring(1, 3) + "00" + data.substring(5, 7));
                });
            }
        } else {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("00" + data.substring(0, 2) + "00" + data.substring(4, 6));
                });
            }
        }
        this.lineCount++;
    }

    handle1101(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            let tempData1 = [], tempData2 = [], tempData3 = [], tempData4 = [];
            tempDotCellLineData[this.lineCount].forEach(data => {
                tempData1.push(data.substring(0, 2));
                tempData2.push(data.substring(4, 6));
            });
            if (tempDotCellLineData[this.lineCount + 1]) {
                tempDotCellLineData[this.lineCount + 1].forEach(data => {
                    tempData3.push(data.substring(3, 4) + "0");
                    tempData4.push(data.substring(7, 8) + "0");
                });
            } else {
                tempDotCellLineData[this.lineCount].forEach(() => {
                    tempData3.push("000");
                    tempData4.push("000");
                });
            }
            tempData1.forEach((data, i) => {
                dotCellLineData.push(tempData3[i] + data + tempData4[i] + tempData2[i]);
            });
        }
        this.lineCount++;
    }

    handle1110(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (numberOfPins != this.DOT_CELL_PIN) {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("0" + data.substring(1, 4) + "0" + data.substring(5, 8));
                });
            }
        } else {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("0" + data.substring(0, 3) + "0" + data.substring(4, 7));
                });
            }
        }
        this.lineCount++;
    }

    setLineDiff(i, mode, complete = false) {
        const commandCode = mode === "GRAPHIC" ? "00" : "80"
        const step = i - 1

        this.SubString = this.stringwithPadding.substring(step * this.numCell * 2, ((step + 1) * this.numCell * 2))
        if (complete) {
            this.dotPadSendModule.setRefreshMode(RefreshMode.LIVE_DISPLAY)
        } else {
            this.dotPadSendModule.setRefreshMode(RefreshMode.GRAPHIC_DISPLAY)
        }
        return this.dotPadSendModule.setDotPadLineCommandDiff(i, commandCode, this.SubString, !complete)
    }

    convertPixelToDotCell(pixel) {
        let dotCellLineData = [];
        const width = this.VOXEL_COL_NUM;
        const height = this.VOXEL_ROW_NUM;
        const numWidthDot = 2;  // 가로 2개씩 묶음
        const numHeightDot = 4; // 세로 4개씩 묶음

        for (let i = 0; i < height; i += numHeightDot) {
            for (let j = 0; j < width; j += numWidthDot) {
                let byte = 0x00;

                // 1차원 배열에서의 인덱스 계산: row * VOXEL_COL_NUM + col
                if (i < height && j < width && pixel[i * width + j]) byte |= 0x01;
                if ((i+1) < height && j < width && pixel[(i+1) * width + j]) byte |= 0x02;
                if ((i+2) < height && j < width && pixel[(i+2) * width + j]) byte |= 0x04;
                if ((i+3) < height && j < width && pixel[(i+3) * width + j]) byte |= 0x08;
                if (i < height && (j+1) < width && pixel[i * width + (j+1)]) byte |= 0x10;
                if ((i+1) < height && (j+1) < width && pixel[(i+1) * width + (j+1)]) byte |= 0x20;
                if ((i+2) < height && (j+1) < width && pixel[(i+2) * width + (j+1)]) byte |= 0x40;
                if ((i+3) < height && (j+1) < width && pixel[(i+3) * width + (j+1)]) byte |= 0x80;

                dotCellLineData.push(byte);
            }
        }

        // 바이트 배열을 16진수 문자열로 변환
        return dotCellLineData.map(byte => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
    }

    getDisplayComplete() {
        return this.dotPadSendModule.getDisplayComplete()
    }
}

export {
    DotpadSDK
};
